import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: grey[200],
            paddingLeft: `${theme.spacing(2)}px`,
            fontSize: theme.typography.subtitle1.fontSize,
            color: theme.palette.primary.dark,
            cursor: 'pointer',
        },
    })
);
